package dev.lingvo.site.ds

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/**
 * Secondary body text — the sentence under a heading, the note under a control.
 *
 * **Thirty-eight files had declared this privately, byte for byte identical.** A `<p>` in
 * `textSecondary` at `TypeScale.Small` with the user-agent margin reset is not a page's local
 * decision; it is the design system's smallest paragraph, and every page reinventing it meant a
 * change to secondary text could only ever reach one screen at a time.
 *
 * `P`, not a `Span`: this is a paragraph, and the margin reset is load-bearing precisely because the
 * user agent supplies one that would otherwise break the rhythm of the card it sits in.
 */
@Composable
fun LMuted(text: String, modifier: Modifier = Modifier) {
    P(
        Modifier
            .color(ColorMode.current.toSitePalette().textSecondary)
            .fontSize(TypeScale.Small)
            .margin(0.px)
            .then(modifier)
            .toAttrs(),
    ) {
        Text(text)
    }
}
